<div *ngIf="showLoading" class="loading-div-tiny" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="small progress" alt="Loading..."><div class="prog1"><div class="prog2"></div></div></div>
    </div>
</div>
<ng-container *ngIf="!showLoading">
    <div *ngIf="!moreWaysToUseData || moreWaysToUseData && moreWaysToUseData.length === 0">
        <div class="more-ways-to-use-container">
            <div class="more-ways-to-use-logo-container">
                <img aria-hidden="true" class="more-ways-to-use-logo" src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/GroceryBag.svg" alt="More ways to use logo" />
            </div>

            <div class="more-ways-to-use-body">
                <h2 class="more-ways-to-use-heading-size">No extra rewards available at this time</h2>
                <p class="more-ways-to-use-description-text">We still have a ton of grocery rewards for you to checkout.</p>
            </div>
            <div class="more-ways-to-use-no-points-footer">
                <button type="button" class="btn btn-xl btn-primary body-text more-ways-to-use-no-points-footer__button" (click)="openRewardsPage()" (keypress)="openRewardsPage()" aria-label="Start earning, redirect to rewards page">
                    View rewards
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="!moreWaysToUseData || moreWaysToUseData && moreWaysToUseData.length > 0">
        <div *ngIf="!showLoading" class="point-reward-grid-container">
        <div class="reward-grid">
            <ng-container *ngFor="let reward of moreWaysToUseData">
                <point-reward-card [ngClass]="rewardCardDisabled ? 'reward-grid-itme' : 'reward-card-container'" [reward]="reward" [appHostURL]="appHostURL" [userInfo]="userInfo" [currentEnvironment]="currentEnvironment" [enableCashReward]="enableCashReward" [isPointScoreCardFlow]="pointScoreCardFlow" [rewardsResponseObj]="rewardsResponseObj" [isMoreWaysToUseFlow]="isMoreWaysToUseFlow" (callMoreWaysToUseApi)="triggerMoreWaysToUseApi($event)"></point-reward-card>
            </ng-container>
        </div>
        </div>
    </div>
</ng-container>

